import React, { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import useApiHttp from "../../hooks/use-http";

//img
// import logo from "../../assets/svg/jiophotos-logo.svg";
// import logo from "../../assets/svg/jcevents-logo.svg";
import logo from "../../assets/png/JioCloud-Logo.png";
//css
import classes from "./LoginPage.module.css";
import PageLoader from "../../components/UI/Loader/PageLoader";
import { Text } from "@jds/core";
import { authActions } from "../../store/state-slices/auth";
import { useDispatch } from "react-redux";
import { setEventNotFoundJitoUser } from "../../store/state-slices/modalControl";

export default function LoginPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const params = new URLSearchParams(useLocation().search);
  const jwt = params.get("jwt");
  const dcCode = params.get("dcCode");
  const eventJWT = params.get("eventJWT");
  if (eventJWT) localStorage.setItem("eventJWT", eventJWT);
  const { sendRequest: loginApi, isLoading: isLoadingLoginApi } = useApiHttp();
  const loginApiHandle = () => {
    loginApi(
      {
        base: "AUTHV2",
        url: `user/login`,
        method: "POST",
        isBearer: false,
        body: {
          jcJwt: jwt,
          deviceType: "WEB",
        },
      },
      null,
      (data) => {
        localStorage.authToken = data.data.accessToken;
        localStorage.refreshToken = data.data.refreshToken;
        localStorage.dcCode = dcCode === "jmng" ? "jmng1" : dcCode;
        navigate("/home");
      },
      (err, data) => {
        if (data?.statusCode === 401) {
          localStorage.clear();
          window.location.href = process.env.REACT_APP_DOMAIN;
        }
      },
    );
  };

  useEffect(() => {
    loginApiHandle();
  }, []);

  return (
    <>
      <header className="header">
        <div className={classes["header__container"]}>
          <NavLink to={"/sign"} className={classes["header__logo-box"]}>
            <Stack direction="row" gap={1} alignItems="center">
              <img src={logo} alt="jio photos logo" style={{ width: "40px" }} />
              <Text text="JioAICloud" appearance="body-m-bold" color="white" />
            </Stack>
          </NavLink>
        </div>
      </header>
      <Box>{isLoadingLoginApi && <PageLoader />}</Box>
    </>
  );
}
